import type {
  RevenueProps,
  UserTraits,
} from '@src/Tracking/catalog';
import type {
  TrackingAdapter,
  TrackingEventName,
  TrackingPayload,
} from '@src/Providers/Tracking/TrackingContext';

/**
 * Dev-only logger adapter. Logs every event/identify/revenue call so you
 * can verify wiring in browser devtools without an external tool. Enable
 * via apiConfig.tracking.consoleAdapterEnabled.
 */
export const createConsoleAdapter = (): TrackingAdapter => ({
  name: 'console',
  receivesAll: true,
  isEnabled: () => true,
  track: (event: TrackingEventName, props?: TrackingPayload) => {
    // eslint-disable-next-line no-console
    console.log('[TRACK]', event, props);
  },
  identify: (userId: string, traits?: UserTraits) => {
    // eslint-disable-next-line no-console
    console.log('[IDENTIFY]', userId, traits);
  },
  trackRevenue: (rev: RevenueProps) => {
    // eslint-disable-next-line no-console
    console.log('[REVENUE]', rev);
  },
});
